<script setup>
    import { ref, onMounted, computed, getCurrentInstance, defineProps } from 'vue'
    import { useRouter } from 'vue-router'
    import SNB from '../../../../../layouts/nav/SNB.vue'
    import mypageUserResumeService from "../../../services/mypage/mypageUserResumeService";
    import { usePageLoadingStore } from "../../../../../stores/pageLoading";
    import _ from 'lodash'
    import UserMatchingResumeCreateModal from "../../../components/modal/mypage/UserMatchingResumeCreateModal.vue";
    import MyPageResumeModal from "../../../components/modal/mypage/MyPageResumeModal.vue";
    import MatchingResumeModal from "../../../components/modal/matching/MatchingResumeModal.vue";
    import {useMatchingUpdateStore} from "../../../stores/matching/matchingUpdateStore";
    import mypageMatchingService from "../../../services/mypage/mypageMatchingService";
    import { useAlertStore } from '../../../../../stores/alertStore';
    import KSATextButton from "@/components/ui-components/button/KSATextButton.vue";
    import JobFairCorpInfoModal from "@/pages/user/components/modal/jobFair/JobFairCorpInfoModal.vue";
    import mypageCorpInfoService from "@/pages/user/services/mypage/mypageCorpInfoService";
    const { $alert, $confirm } = useAlertStore();

    const globals = getCurrentInstance().appContext.config.globalProperties;

    const { $pageListPorpId } = globals;

    const router = useRouter()
    const loadingStore = usePageLoadingStore()

    const list = ref([]);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(1);
    const totalCount = ref(0);
    const matchingResumeModal = ref(null);
    const corpInfoModal = ref(null);

    const pageSizeGroup = ref([
      { label:"10개씩 보기", value: "10" },
      { label:"30개씩 보기", value: "30" },
      { label:"50개씩 보기", value: "50" },
      { label:"100개씩 보기", value: "100" },
      { label:"500개씩 보기", value: "500" }
    ])

    // 모달
    const userMatchingResumeCreateModal = ref(null);
    const userMatchingJobResumeModal = ref(null);

    let letUserGb = ''
    let corpMasterYn = ''

    const shouldRender = ref(true);
    const getUserInfo = async () => {
      loadingStore.loading = true;
      const userInStorage = sessionStorage.getItem('user');
      if(userInStorage) {
        const { userGb, userInfo } = JSON.parse(userInStorage)
        letUserGb = userGb
        corpMasterYn = userInfo.corpMasterYn;
      }
      loadingStore.loading = false;
    }

    const isModal = localStorage.getItem('isModalVisible')

    onMounted( async () => {
      retrieveList();

      await getUserInfo()
      if(letUserGb === 'STUDENT') {
        if(isModal === 'true') {
          matchingResumeModal.value.show();
        }
      } else {
        shouldRender.value = false;
        await $alert("학생/취업준비생 회원만 지원 가능합니다.");
        router.go(-2);
      }
    })

    const retrieveList = () => {

        let paramObj = {
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        // console.log(paramObj);
        loadingStore.loading = true;
        mypageUserResumeService.retrieveApplicantListPagingByUserId(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    list.value = $pageListPorpId(result.content, totalCount.value, pageSize, currentPage.value);
                    //console.log(list.value)
                }
            }).catch( (error) =>  {
                loadingStore.loading = false;
                console.log(error);
            });
    }

    const onSelectedPage = (pageNo) => {
        currentPage.value = pageNo;
        retrieveList();
    }

    // 기업정보 보기
    const onClickViewCorp = async (corpId) => {
      corpInfoModal.value.matchingCorporationDetail(corpId);
      corpInfoModal.value.show();
    }

    // 이력서 보기
    const onClickUserMatchingResumeDetail = (resumeId) => {
        userMatchingJobResumeModal.value.init(false);
        userMatchingJobResumeModal.value.retrieveUserMatchingJobResumeDetail(resumeId, 0);
        userMatchingJobResumeModal.value.show();
    }

    // 이력서 작성 버튼
    const onClickCreateUserMatchingResume = async () => {

        mypageUserResumeService.retrieveAgreeInfoProvYn()
            .then( (res) => {
                if ( res.data.result.agreeInfoProvYn === "Y" ) {
                    showUserMatchingResumeCreateModal();
                } else {
                    confirmAgreeInfoProvYnChange();
                }
            }).catch( (res) =>  {
            console.log(res);
            $toast('error', '오류가 발생하였습니다.');
        });

    }

    // 제3자 정보 제공 동의처리 의사 확인
    const confirmAgreeInfoProvYnChange = async () => {
        const ok = await $confirm(["개인정보 제공에 동의하나요?", "동의하지 않을 시 이력서 작성 후 전송을 할 수 없습니다."], "동의", "동의하지 않음");
        if ( ok ) { // 동의
            changeAgreeInfoProvYn();
        } else {    // 동의하지 않음

        }
    }

    // 제3자 정보 제공 동의여부 변경
    const changeAgreeInfoProvYn = () => {

        loadingStore.loading = true;

        let paramObj = {
            agreeInfoProvYn: "Y",
        }

        mypageUserResumeService.changeAgreeInfoProvYnState(paramObj)
            .then( (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    //let result = res.data.result;
                    //console.log(result);
                    showUserMatchingResumeCreateModal();
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });

    }

    // 이력서 작성 모달 실행
    const showUserMatchingResumeCreateModal = async () => {
        userMatchingResumeCreateModal.value.init();
        await userMatchingResumeCreateModal.value.show();
    }

    // 페이지당 개수 변경
    const onSelectPageSize = (option) => {
      pageSize.value = option.value;
      currentPage.value = 1;
      retrieveList();
    }


    // 입사지원 상태변경
    const onClickApplyStateGb = async (resumeId, corpId, stateGb) => {
      if (stateGb === "01") {
        stateGb = "02"
      }
      const ok = await $confirm(["지원을 취소 하시겠습니까?", "'지원취소'로 상태가 변경됩니다."], "지원 취소");
      if(!ok) {
        return -1;
      } else {
        let paramObj = {
          corpId: corpId,
          resumeId: resumeId,
          applyStateGb: stateGb,
        }
        mypageUserResumeService.updateApplyStateGb(paramObj)
            .then( (res) => {
              loadingStore.loading = false;
              if(res.data.code.toLowerCase() === 'success') {
                $alert("변경하였습니다.");

                retrieveList();
              } else {
                $alert("변경을 실패하였습니다.");
                console.log(res);
              }
            })
            .catch( (res) =>  {
              loadingStore.loading = false;
              $alert("변경을 실패하였습니다.");
            });
      }
    }

</script>

<template>
    <div v-if="shouldRender">
      <div class="list-top">
        <p>총 <span>{{ $number(totalCount) }}</span>건</p>
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
      </div>
      <div class="table-form board-mobile-vertical">
        <table>
          <tr>
            <th>기업명</th>
            <th>이력서</th>
            <th>관심 카테고리</th>
            <th>입사 지원일</th>
            <th>상태</th>
            <th>상태변경</th>
          </tr>
          <tr v-for="(proposal) in list">
            <td data-title="기업명 : " class="clickable blue text-overflow long-overflow" @click="onClickViewCorp(proposal.corpId)">{{ proposal.corpName }}</td>
            <td data-title="이력서 : "><KSATextButton class="clickable resume" text="이력서 보기" @click="onClickUserMatchingResumeDetail(proposal.resumeId)" /></td>
            <td data-title="관심 카테고리 : ">{{ proposal.interests }}</td>
            <td data-title="입사지원 현황 : ">{{ $yyyymmddHHmmss(proposal.createDate)}}</td>
            <td data-title="상태 : ">
              <span v-if="proposal.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',proposal.applyStateGb) }}</span>
              <span v-else-if="proposal.applyStateGb === '03' || proposal.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',proposal.applyStateGb) }}</span>
              <span v-else-if="proposal.applyStateGb === '04' || proposal.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',proposal.applyStateGb) }}</span>
              <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',proposal.applyStateGb) }}</span>
            </td>
            <td data-title="상태변경 : ">
              <div v-if="proposal.applyStateGb === '01'">
                <KSATextButton class="clickable black_button" text="지원취소" @click="onClickApplyStateGb(proposal.resumeId, proposal.corpId, '02')"/>
              </div>
              <div v-else>
                -
              </div>
            </td>
          </tr>
        </table>
        <div class="result-none" v-if="list.length === 0">
          입사 지원 내역이 없습니다.
        </div>
      </div>
      <Paginate
          v-if="list.length > 0"
          v-model="currentPage"
          :page-count="totalPages"
          :click-handler="onSelectedPage"
      />
    </div>
    <div v-else class="white-background"></div>
    <JobFairCorpInfoModal ref="corpInfoModal"/> <!-- 기업정보 보기 -->
    <MatchingResumeModal v-if="isModal" ref="matchingResumeModal" />
    <UserMatchingResumeCreateModal ref="userMatchingResumeCreateModal"/>
    <MyPageResumeModal ref="userMatchingJobResumeModal"/>
</template>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    .blue {
      color: $blue_color;
    }

    /* Filter */
    .filter-wrap {
        margin-bottom: 40px;
        &.open {
            p {
                &:before {
                    transition-duration: 0.2s;
                    -webkit-transform: translateY(-50%) rotate(225deg);
                    transform: translateY(-50%) rotate(225deg);
                }
            }
            .filter {
                display: block;
                border-bottom: $border_line;
            }
        }
        p {
            position: relative;
            @include font-size_md;
            background: $gray-light_color;
            border: $border_line;
            font-weight: 700;
            cursor: pointer;
            padding: 10px 20px;
            &:before {
                content: "";
                position: absolute;
                top: 50%;
                right: 20px;
                display: block;
                width: 8px;
                height: 8px;
                border-top: 1px solid #000000;
                border-left: 1px solid #000000;
                -webkit-transform: translateY(-50%) rotate(45deg);
                transform: translateY(-50%) rotate(45deg);
                transition-duration: 0.2s;
            }
        }
        .filter {
            display: none;
            border-left: $border_line;
            border-right: $border_line;
            dl {
                display: flex;
                align-items: center;
                dt {
                    display: flex;
                    align-items: center;
                    width: 180px;
                    height: 48px;
                    font-weight: 700;
                    padding: 10px 10px 10px 20px;
                    .select {
                        font-weight: initial;
                    }
                }
                dd {
                    width: calc(100% - 180px);
                    padding: 10px 20px 10px 0;
                    .grid {
                        span {
                            margin: 0 4px;
                        }
                    }
                }
                &:first-of-type {
                    padding-top: 10px;
                }
                &:last-of-type {
                    padding-bottom: 10px;
                }
            }
            .btn-wrap {
                border-top: $border_line;
                padding: 10px 20px;
                margin: 0;
                button {
                    margin: 0 5px;
                }
            }
            .text-box {
                margin-top: 0;
            }
        }
    }

    .clickable {
      cursor: pointer;
      color: #3843AF;
      text-decoration: underline;
      &.proposal {
        &:hover {
          font-weight: 700;
          // text-decoration: underline;
        }
      }
      &.resume {
        color: #3C72FF;
        &:hover {
          font-weight: 700;
          text-decoration: underline;
        }
      }


    }

    .white-background {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
    }

    .blueTextButton { color: $blue_color; }
</style>